import { API } from '#lib/network/API';
import { usePagination } from '#lib/reactQuery/hooks/usePagination';
import { InvestmentAlertsKeys } from './InvestmentAlerts.keys';
import { InvestmentAlert } from '#/models/investment/alert/InvestmentAlert';

export const useGetPaginatedInvestmentAlerts = () => {
  const queryKey = InvestmentAlertsKeys.byPagination();
  return usePagination<InvestmentAlert[]>(queryKey, API.investment.alerts.getByPaginated());
};
